<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div class="table__search-input-wrapper">
        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
          v-model="queryString"
        />
        <search-icon />
      </div>
    </div>
<h1>skrep</h1>
    <table class="custom-table responsive-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Function</th>
          <th>Role</th>
          <th> Phone no</th>
          <th>Date Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="!loading && filteredUsers.length == 0">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>No users to display!</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
      <tbody v-if="!loading">
        <tr v-for="user in filteredUsers" :key="user.id">
          <td class="d-flex align-items-center">
            <!-- <span
              ><img
                src="@/assets/images/settings/user-table-dummy-img.png"
                alt="user image"
            /></span> -->
            <span class="">{{ user.firstName }} {{ user.lastName }}</span>
          </td>
          <td>{{ user.workEmail }}</td>
          <td>-</td>
          <td>{{ user.role }}</td>
          <td>{{ user.groupId }}</td>
          <td>{{ user.createdAt | formatDate }}</td>
        </tr>
      </tbody>
    </table>
    <loader v-if="loading" />
    <pagination />
  </div>
</template>

<script>
import Pagination from "@/components/UI/pagination";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      selectedRowId: null,
      isDeactivateModal: false,
      isAddToGroupModal: false,
      users: [],
      selectedUser: {},
      loading: true,
      groups: [],
      queryString: "",
    };
  },
  computed: {
    filteredUsers() {
      return this.filterArray(this.users, this.queryString);
    },
  },
  mounted() {
    this.shouldFetchUsers();
    this.shouldFetchGroupNames();
  },
  watch: {
    fetchUsers() {
      this.getAllUsers();
    },
  },
  methods: {
    async getAllUsers() {
      try {
        let response = await this.$_getAllUsers();
        console.log(response);
        this.loading = false;
        this.users = response.data.findGroupUser.filter((user) => {
          return (user.isDeactivated = "false");
        });
        localStorage.setItem("users", JSON.stringify(this.users));
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    editUser(userId) {
      localStorage.setItem("userId", userId);
      this.$router.push({ name: "EditUser" });
    },
    shouldFetchUsers() {
      let users = JSON.parse(localStorage.getItem("users"));
      if (users) {
        this.users = users;
        this.loading = false;
      } else {
        this.getAllUsers();
      }
    },
    shouldFetchGroupNames() {
      let groupNames = JSON.parse(localStorage.getItem("groupNames"));
      if (groupNames) {
        this.groups = groupNames;
      } else {
        this.getAllGroupsName();
      }
    },
    async getAllGroupsName() {
      try {
        let response = await this.$_getAllGroupsName();
        console.log(response);
        this.groups = response.data.findGroup;
        localStorage.setItem("groupNames", JSON.stringify(this.groups));
      } catch (error) {
        this.handleError(error);
        console.log(error);
      }
    },
    addUserToGroup(user) {
      this.selectUser(user);
      this.isAddToGroupModal = true;
    },
    selectUser(user) {
      this.selectedUser = user;
    },
    deactivateUser(user) {
      this.selectUser(user);
      this.isDeactivateModal = true;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    showDeleteModal(userId) {
      this.$emit("show-delete-modal", ["User", userId]);
      this.resetSelectedRow();
    },
    showViewRoleModal() {
      this.$emit("show-view-role-modal");
      this.resetSelectedRow();
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
    resetUsers() {
      localStorage.removeItem("users");
    },
  },
};
</script>

<style scoped></style>
